export const ROUTES = { // eslint-disable-line import/prefer-default-export
  SETTINGS: {
    MEMBERSHIP: '/settings/membership',
  },
};



// WEBPACK FOOTER //
// ./src/config/routes.js